import http from "../http-common";

class PlanificationService {
  getAll(params) {
    return http.get("/planifications", { params });
  }

  get(id) {
    return http.get(`/planifications/${id}`);
  }

  create(data) {
    return http.post("/planifications", data);
  }

  update(id, data) {
    return http.put(`/planifications/${id}`, data);
  }

  updateAssignments(id, assignments) {
    return http.put(`/planifications/${id}/assignments`, { assignments });
  }

  delete(id) {
    return http.delete(`/planifications/${id}`);
  }

  getTrashed() {
    return http.get("/planifications/trashed/list");
  }

  restore(id) {
    return http.post(`/planifications/${id}/restore`);
  }

  send(id) {
    return http.post(`/planifications/${id}/send`);
  }

  setStatus(id, status) {
    return http.post(`/planifications/${id}/status`, { status });
  }

  updateSection(sectionId, data) {
    return http.put(`/planification-sections/${sectionId}`, data);
  }

  addSectionComment(sectionId, comment, setNeedsChanges = false) {
    return http.post(`/planification-sections/${sectionId}/comments`, {
      comment,
      set_needs_changes: setNeedsChanges,
    });
  }

  async uploadAttachment(planificationId, file) {
    const form = new FormData();
    form.append("file", file);
    return http.post(`/planifications/${planificationId}/attachments`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  async uploadSectionAttachment(sectionId, file) {
    const form = new FormData();
    form.append("file", file);
    return http.post(`/planification-sections/${sectionId}/attachments`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  deleteAttachment(attachmentId) {
    return http.delete(`/attachments/${attachmentId}`);
  }

  generatePdf(id) {
    return http.get(`/planifications/${id}/pdf`, {
      responseType: 'blob',
    });
  }
}

export default new PlanificationService();
